import { render, staticRenderFns } from "./ConsolidatedReportDetails.vue?vue&type=template&id=1b71b8d3"
import script from "./ConsolidatedReportDetails.vue?vue&type=script&lang=js"
export * from "./ConsolidatedReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports